"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
require("./Input.scss");
var InputType;
(function (InputType) {
    InputType["email"] = "email";
    InputType["password"] = "password";
    InputType["number"] = "number";
    InputType["text"] = "text";
})(InputType = exports.InputType || (exports.InputType = {}));
var Input = function (props) {
    var className = props.className, _a = props.type, type = _a === void 0 ? InputType.text : _a, _b = props.allowSubmittingDisabledState, allowSubmittingDisabledState = _b === void 0 ? true : _b, width = props.width, fast = props.fast, rest = __rest(props, ["className", "type", "allowSubmittingDisabledState", "width", "fast"]);
    var Component = react_1.useMemo(function () { return (fast ? formik_1.FastField : formik_1.Field); }, [fast]);
    return (react_1.default.createElement(Component, { name: props.name, placeholder: props.placeholder }, function (_a) {
        var field = _a.field, form = _a.form, meta = _a.meta;
        var value = field.value;
        var fieldValue = value === null || typeof value === 'undefined' ? '' : value;
        return (react_1.default.createElement("input", __assign({}, field, { disabled: form.isSubmitting && allowSubmittingDisabledState }, rest, { value: fieldValue, type: type, className: classnames_1.default('form-input', className, {
                'form-input--error': !!meta.error,
                'form-input--w-xs': width && width === 'xs',
                'form-input--w-sm': width && width === 'sm',
                'form-input--w-md': width && width === 'md',
                'form-input--w-lg': width && width === 'lg',
            }) })));
    }));
};
exports.default = Input;
//# sourceMappingURL=index.js.map